<template>
  <section class="n-view-register h-screen p-10 flex justify-center items-center">
    <NCard class="w-full max-w-[450px] shadow-md">
      <div class="text-center">
        <img class="mx-auto p-8" src="/images/logo-dark.png" alt="" />
        <div class="text-lg p-4">
          <div>
            <span class="m-4 font-bold">{{$tl('passwordResetNoticeTitle')}}</span>
          </div>
        </div>
        <div class="text-lg p-4">
          <div>
            <span class="m-4 font-bold">{{$tl('goLogin')}}</span>
          </div>
        </div>
        <div class="text-lg p-4">
          <div>
            <RouterLink to="/login">{{ $tl('back') }}</RouterLink>
          </div>
        </div>
      </div>

      <div class="mt-10 mb-3 text-center text-base text-gray-600 grid items-center gap-3 grid-flow-col place-content-center">
        {{ COPYRIGHT }}
        <NChannelSwitch />
        <NLanguageSwitcher />
        <NHelper />
      </div>
    </NCard>
  </section>
</template>

<script setup>
import {useLanguage, useRouter} from '@front/hooks';
import {COPYRIGHT} from '@front/constant';
import {computed} from 'vue';

const { tl, t, PREFIX } = useLanguage();
const { router, routerTo } = useRouter();
const launchScheme = computed(() => router.currentRoute.value.params.launchScheme);
const fromPc = computed(() => (launchScheme.value ?? 'pc') === 'pc');

if (!fromPc.value) {
  // 拉起其他平台
  window.location.href = launchScheme.value;
}

</script>

<style lang="less">
.n-view-register {
  background-image: url('/images/shape01.png');
  background-position: center;

  .n-language-switcher {
    gap: 6px;
  }
}
</style>
